import React from 'react';
import { MapPin, Mail, Globe } from 'lucide-react';
import Logo from './Logo';
import { CONTACT, NAV_LINKS } from '../mock';

const scrollTo = (id) => (e) => {
  e.preventDefault();
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const Footer = () => {
  return (
    <footer className="footer-strip border-t border-white/5">
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 lg:px-12 py-10 grid grid-cols-1 md:grid-cols-4 gap-6 items-start">
        <div className="md:col-span-2">
          <Logo />
          <p className="text-white/60 text-sm mt-3 max-w-md">Mission-critical communication built for the world&apos;s most demanding environments.</p>
        </div>
        <div>
          <div className="text-[#F5901F] text-xs font-bold tracking-[0.2em] mb-3">NAVIGATE</div>
          <ul className="space-y-2 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} onClick={scrollTo(l.href)} className="text-white/75 hover:text-[#F5901F] transition-colors">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-[#F5901F] text-xs font-bold tracking-[0.2em] mb-3">GET IN TOUCH</div>
          <div className="space-y-3 text-sm">
            <div className="flex items-start gap-2 text-white/80"><MapPin className="text-[#F5901F] mt-0.5 flex-shrink-0" size={16} /><span>{CONTACT.address}</span></div>
            <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 text-white/80 hover:text-[#F5901F] transition-colors"><Mail className="text-[#F5901F]" size={16} />{CONTACT.email}</a>
            <a href={`https://${CONTACT.website}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-white/80 hover:text-[#F5901F] transition-colors"><Globe className="text-[#F5901F]" size={16} />{CONTACT.website}</a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-[1600px] mx-auto px-4 md:px-8 lg:px-12 py-4 text-xs text-white/50 flex flex-col md:flex-row justify-between gap-2">
          <span>&copy; {new Date().getFullYear()} Bluu Sky Private Limited. All rights reserved.</span>
          <span>HERTZX&trade; Integrated Hands-Free Communication System</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
